import React, { useEffect, useState } from "react"
import Button from "@components/objects/Button/Button"
import ImageUploader from "../../global/ImageUploader/ImageUploader"
import DatoImageViewer from "../DatoImageViewer/DatoImageViewer"
import * as styles from "./SupplierSignupForm.module.scss"

const FormImages = ({
  data,
  photos,
  handleChangeVideo,
  handleChangeFile,
  disableSubmit,
  showCurrentimages,
  setShowCurrentimages,
}) => {
  const handleReplaceImages = () => {
    // eslint-disable-next-line
    if (
      window.confirm(
        "You are about to remove all your uploaded images and will lose any associated tags. Are you sure you want to continue?"
      )
    ) {
      setShowCurrentimages(false)
    }
  }

  return (
    <section>
      <h3>Images</h3>
      <p>
        It is proven that high quality imagery improves the chances of you receiving enquiries for
        your services. Please choose the best imagery you have of past events that you have worked
        on or images from your portfolio that you are especially proud of! This is your chance to
        showcase your profile!
      </p>

      <p>
        We require one featured image as well as up to 20 additional images to be used in your
        gallery.
      </p>
      <p>Please ensure that images meet the following requirements:</p>
      <ul className={styles.highlightText}>
        <li>
          <strong>Landscape</strong> images only <strong>*</strong>
        </li>
        <li>
          Image width must be more than <strong>1600</strong>
        </li>
        <li>
          Each image must be <strong>less than 5MB</strong> in filesize
        </li>
        <li>
          File type must either be <strong>jpeg / jpg or png</strong>
        </li>
      </ul>

      <p className={styles.highlightText}>
        <i>
          <strong>*</strong> Portrait images will be cropped when used as a cover photo or in the
          gallery, however users may click into the gallery to view the original full size image
        </i>
      </p>

      {showCurrentimages ? (
        <div>
          <h3>Current Images</h3>
          <DatoImageViewer photos={photos} />
          <Button text="Replace all images" onClick={handleReplaceImages} />
        </div>
      ) : (
        <div>
          <div>
            <label>Featured Image*</label>
            <ImageUploader
              required
              name="coverphoto"
              handleChangeFile={handleChangeFile}
              disableSubmit={disableSubmit}
            />
          </div>
          <div>
            <label>Additional Images</label>
            <ImageUploader
              name="photos"
              allowMultiple
              handleChangeFile={handleChangeFile}
              disableSubmit={disableSubmit}
            />
          </div>
        </div>
      )}

      <div>
        <br></br>
        <h3>Featured Video</h3>
        <p>
          If you have a video copy and paste the address of the page containing a YouTube or Vimeo
          video.
          <br />
        </p>
        <p>
          Otherwise if you have a non youtube or vimeo video please send to{" "}
          <a href="mailto:supplier@houseofpartyplanning.com">supplier@houseofpartyplanning.com</a>
        </p>
        <input
          type="text"
          id="coverVideo"
          name="coverVideo"
          onChange={handleChangeVideo}
          value={data.coverVideo?.url}
          placeholder="e.g. https://www.youtube.com/watch?v=C0DPdy98e4c"
        />
      </div>
    </section>
  )
}

export default FormImages
